import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { ALL_THEME_CLASSES, resolveTheme } from "@/lib/themes";

const ThemeContext = createContext({ theme: "theme-gmh", setTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("theme-gmh");
  const value = useMemo(() => ({ theme, setTheme }), [theme]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);

export const RouteThemeSync = () => {
  const location = useLocation();
  const { setTheme } = useTheme();
  useEffect(() => {
    const next = resolveTheme(location.pathname);
    const root = document.documentElement;
    ALL_THEME_CLASSES.forEach((c) => root.classList.remove(c));
    root.classList.add(next);
    setTheme(next);
    root.setAttribute("data-theme", next.replace("theme-", ""));
  }, [location.pathname, setTheme]);
  return null;
};

export function currentBrandSlug(theme) {
  if (!theme) return "gmh";
  return theme.replace("theme-", "");
}
